import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChUpdatePsychologicalPsychoTherapyMutation as useChUpdatePsychologicalPsychoTherapyMutationType } from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChUpdatePsychologicalPsychoTherapyMutation.graphql"

const mutation = graphql`
  mutation useChUpdatePsychologicalPsychoTherapyMutation($input: Ch_updatePsychotherapyPrescriptionInput!) {
    ch_updatePsychotherapyPrescription(input: $input) {
      ch_PsychotherapyPrescription {
        id
        ...chPsychologicalPsychoTherapyFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChUpdatePsychologicalPsychoTherapyMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChUpdatePsychologicalPsychoTherapyMutationType>(
    mutation,
    params,
  )

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChUpdatePsychologicalPsychoTherapyMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChUpdatePsychologicalPsychoTherapyMutation }
